import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 w-full bg-primary-800 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                91<span className="text-accent-400">免费</span>影视
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              91免费影视平台专注于为影视爱好者提供丰富多样的高清电影与电视剧资源。我们致力于以清晰的分类、便捷的搜索与筛选，帮助每一位观众快速找到想看的作品，享受沉浸式的观影体验。
            </p>
            <p className="mt-3 text-xs text-background-400">
              本站所有影视内容、人物及评分均为虚构演示数据，仅用于产品展示，不提供任何真实播放与下载服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wide text-background-50">
              <span className="text-accent-400">#</span> 影视分类
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wide text-background-50">
              <span className="text-accent-400">#</span> 关于平台
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-300 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-background-300 transition-colors hover:text-accent-300">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/favorites" className="text-sm text-background-300 transition-colors hover:text-accent-300">
                  我的收藏
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-300 transition-colors hover:text-accent-300">
                  搜索影视
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-700 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-400">
            Copyright © {year} 91免费影视平台 · 演示站点 · 仅供学习交流使用
          </p>
          <p className="text-xs text-background-400">
            所有内容为虚构演示 · 无真实视频播放与下载接口
          </p>
        </div>
      </div>
    </footer>
  );
}